import { APIProvider } from '@vis.gl/react-google-maps';
import { BrowserRouter } from 'react-router-dom';
import classes from './app.module.css';
import { config, mapTypes } from './config/config';
import { ItineraryMap } from './features/itinerary-map';
import { WorldMap } from './features/world-map';
import { QueryProvider } from './lib/query-provider';

/**
 * An app to demonstrate map components
 */
export function App() {
  return (
    <BrowserRouter>
      <QueryProvider>
        <APIProvider apiKey={config.mapsApiKey}>
          <div className={classes.app}>{config.mapType === mapTypes.itinerary ? <ItineraryMap /> : <WorldMap />}</div>
        </APIProvider>
      </QueryProvider>
    </BrowserRouter>
  );
}
